var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticStyle:{"position":"absolute","font-size":"14px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }